// Kept separate from loan-application so test-project-fields can read these
// enums during import. loan-application imports the package index, which loads
// test-project-fields before loan-application finishes initializing.
export enum FundingSchedule {
  FiftyFifty = "50_50",
  TwentyEighty = "20_80",
  SeventyThirty = "70_30",
  OneHundred = "100",
}

export enum LenderInspectionType {
  BorrowerInvolved = 'Borrower Involved',
  NoBorrowerInvolvement = 'No Borrower Involvement',
}
